import { GetUsersQuery } from "../../generated/graphql"
import { RolesUiDisplayObj } from "../../util/subjectRole"
import { TableStateType } from "../table/tableTypes"
import { getTableStateFromUrlParams } from "../table/tableUtil"
import { ORGANIZATION_COLUMN_ID } from "./column"
import { UsersAdminTableDataI } from "./types"

const formatAdminUsersTableData = (
    data: GetUsersQuery
): UsersAdminTableDataI[] => {
    return data.users.nodes.map((user) => ({
        subjectId: user.id,
        firstName: user.identity?.firstName || "No Name",
        lastName: user.identity?.lastName || "No Name",
        fullName: user.identity?.fullName || "No Name",
        email: user.identity?.email ?? "",
        organization: user.organization.name ?? "",
        role: RolesUiDisplayObj[user.role],
        active: user.identity?.active ?? false,
        organizationMembershipId: user.organizationMemberships?.[0]?.id ?? "",
        managedAccess:
            user.organizationMemberships?.[0]?.managedAccess ?? false,
    }))
}

const usersAdminPageSizeSelectorArray = [10, 25, 50]

const getUsersAdminStateFromUrlQueryParams = (
    searchParams: URLSearchParams
): TableStateType => {
    const defaultState: TableStateType = {
        pageIndex: 0,
        size: usersAdminPageSizeSelectorArray[0],
        sorting: [],
        search: "",
        filter: [],
    }

    return getTableStateFromUrlParams(
        searchParams,
        defaultState,
        usersAdminPageSizeSelectorArray,
        {
            [ORGANIZATION_COLUMN_ID]: (
                value: string,
                state: TableStateType
            ) => {
                state.filter.push({ id: ORGANIZATION_COLUMN_ID, value })
            },
        }
    )
}

export {
    usersAdminPageSizeSelectorArray,
    getUsersAdminStateFromUrlQueryParams,
    formatAdminUsersTableData,
}
